import { createActions } from 'redux-actions';


const actionCreators = createActions({
    AUTH: {
        LOGIN: data => data,

        LOGOUT: undefined,
    },
});

export default actionCreators.auth;
